import React, { Fragment } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useParams } from 'react-router';
import Navbar from './Navbar';
import SubNavbar from './subcomponents/SubNavbar';
import Slider from './subcomponents/Slider';
import Description from './DescriptionProyect';
import Tools from './Tools';
import Github from './Github';


const Proyect = ({ listNav, data }) => {
  const urlData = useParams()
  const urlHeader = `/proyect/${urlData.proyect}`
  const filtro = data.filter(e => e.url == urlHeader)

  return (
    <div>
      <Navbar listNav={listNav}></Navbar>
      <div className="container-fluid">
        <SubNavbar urlData={urlHeader}></SubNavbar>
      </div>
      <Slider filtro={filtro}></Slider>
      <Description data={filtro}></Description>
      <Tools data={filtro}></Tools>
      <Github data={filtro}></Github>
    </div>
  );
}

export default Proyect;
